<nb-layout>

  <nb-layout-header class="header">
    <div class="header-wrapper">
      <div class="logo-container">
        <img class="logo" src="../assets/logo.png" style="padding: 10px;">
      </div>
      <div class="btn-container">
        <a class='btn' href="/">Search</a>
        <a class='btn' href="bookmark">Bookmarks</a>
      </div>
    </div>
</nb-layout-header>
  

  <nb-layout-column style="padding: 0!important;" class="body-container">
    <router-outlet></router-outlet>
  </nb-layout-column>

  <nb-layout-footer class="footer" style="padding: 0 !important;">
    <p>Harshita | Copyright | 2021 | <a href="https://github.com/harshita2216/movie-mark">GitHub</a></p>
    
  </nb-layout-footer>

</nb-layout>